<template>
    <stream-item 
        @select="menuItemSelected"
        :menu-options="menuOptions" 
        icon="note" 
        line-type="dashed" 
        background-colour="#fffcdc"
    >
        <stream-item-header 
            :created-by="data.created_by" 
            :created-at="data.created_at" 
        />
        <div 
            class="stream-item-note-content" 
            v-html="data.content"
        ></div>
    </stream-item>
</template>

<style lang="scss">
    .stream-item-note-content {
        padding: .5rem 1.5rem 1.5rem;
        p { margin-bottom: 0; }
    }
</style>

<script>
    import StreamItemHeader from './StreamItemHeader'
    import StreamItem from '../../elements/stream/StreamItem'
    import { NoteResource } from '../../../classes/Api/Note'

    const menuOptions = [
        {
            id: 'delete',
            icon: 'delete',
            label: 'Delete'
        }
    ]

    export default {
        components: { StreamItem, StreamItemHeader },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                menuOptions
            }
        },
        methods: {
            menuItemSelected(e) {
                if (e.id === 'delete' && confirm('Are you sure you want to delete this note?')) {
                    NoteResource.destroy(this.data.id).then(r => {
                        this.$emit('deleted');
                    }).catch(e => {
                        handleApiError(e)
                    })
                }
            }
        }
    }
</script>